// Livewire with Alpine (must be here to load in page footer)

if (!window.Livewire) {
    import('../../../../../../../vendor/livewire/livewire/dist/livewire.esm').then(module => {
        const { Livewire, Alpine } = module
        // Optionally, attach Livewire and Alpine to the window for global access
        window.Livewire = Livewire
        window.Alpine = Alpine

        /**
         * Add some alpine plugins here
         * Alpine.plugin(YOUR-PLUGIN)
         */

        Livewire.start()
    }).catch(error => {
        console.error('Failed to load Livewire and Alpine:', error)
    })
}

if (window.Livewire)  {
    Livewire.hook('request', ({ options }) => {
        options.headers['X-Powered-By'] = 'Livewire/3';
        options.headers['X-Csp-Nonce'] = document.querySelector("meta[name='csp-nonce']")?.content;
    })

    Livewire.hook('navigate.request', ({ options }) => {
        options.headers['X-Powered-By'] = 'Livewire/3';
        options.headers['X-Csp-Nonce'] = document.querySelector("meta[name='csp-nonce']")?.content;
    })
}
